<template>
    <div class="ajustar-cantidad-producto-final container mt-4 p-4 bg-white border rounded shadow-sm">
      <h3 class="mb-3">
        <font-awesome-icon icon="edit" class="me-2 text-warning" />
        Ajustar Cantidad del Producto Final Bulk
      </h3>
  
      <div class="alert alert-warning">
        <strong>Atención:</strong> Al ajustar la cantidad se modificará automáticamente la materia prima disponible (descuento o devolución).
      </div>
  
      <!-- INFO DEL PRODUCTO -->
      <div class="row mb-4">
        <div class="col-md-4">
          <label><strong>Código Producto Final (Lote)</strong></label>
          <input type="text" class="form-control" :value="producto.codigo" disabled>
        </div>
  
        <div class="col-md-4">
          <label><strong>Código Materia Prima</strong></label>
          <input type="text" class="form-control" :value="producto.materia_prima?.codigo" disabled>
        </div>
  
        <div class="col-md-4">
          <label><strong>Disponible en materia prima</strong></label>
          <input type="text" class="form-control" :value="producto.materia_prima?.cantidad + ' ' + producto.unidad_medida" disabled>
        </div>
      </div>
  
      <!-- AJUSTE DE CANTIDAD -->
      <div class="row mb-3">
        <div class="col-md-4">
          <label>Nueva Cantidad del Producto Final</label>
          <input 
            v-model.number="nuevaCantidad" 
            type="number" 
            class="form-control" 
            :min="0.1" 
            step="0.1"
            required
          >
        </div>
  
        <div class="col-md-8">
          <label>Motivo del Ajuste (obligatorio)</label>
          <textarea v-model="observaciones" class="form-control" rows="3" placeholder="Observaciones..." required></textarea>
        </div>
      </div>
  
      <!-- RESUMEN DEL IMPACTO -->
      <div class="impacto bg-light border rounded p-3 mb-4">
        <h6 class="mb-2">Impacto en materia prima:</h6>
  
        <div v-if="diferenciaCantidad < 0" class="text-success">
          <font-awesome-icon icon="plus-circle" class="me-2" />
          Se devolverán <strong>{{ diferenciaCantidad }}</strong> {{ producto.unidad_medida }} a materia prima.
        </div>
  
        <div v-else-if="diferenciaCantidad > 0" class="text-danger">
          <font-awesome-icon icon="minus-circle" class="me-2" />
          Se descontarán <strong>{{ Math.abs(diferenciaCantidad) }}</strong> {{ producto.unidad_medida }} de materia prima.
        </div>
  
        <div v-else class="text-muted">
          No habrá cambio en materia prima.
        </div>
      </div>
  
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button class="btn btn-outline-secondary" @click="$emit('cancelar')">Cancelar</button>
        <button class="btn btn-success" @click="ajustarCantidad" :disabled="diferenciaCantidad===0">Guardar Ajuste</button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  
  export default {
    name: 'AjustarCantidadproducto',
    components: { FontAwesomeIcon },
    props: {
      producto: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        nuevaCantidad: this.producto.cantidad,
        observaciones: ''
      };
    },
    computed: {
      diferenciaCantidad() {
        return parseFloat((this.nuevaCantidad - this.producto.cantidad).toFixed(1));
      }
    },
    methods: {
      async ajustarCantidad() {
        if (!this.observaciones || this.observaciones.trim() === '') {
          alert("Debe ingresar las observaciones del ajuste.");
          return;
        }
  
        if (!this.nuevaCantidad || this.nuevaCantidad < 0.1) {
          alert("La cantidad debe ser mayor o igual a 0.1.");
          return;
        }
  
        try {
          const res = await axios.put(`/api/producto_final_bulk_ajustarCantidad/${this.producto.id}`, {
            nuevaCantidad: this.nuevaCantidad,
            observaciones: this.observaciones
          });
  
          alert("Cantidad ajustada correctamente");
          this.$emit('ajusteRealizado', res.data.bulk);
        } catch (error) {
          console.error("Error al ajustar la cantidad:", error);
          alert("Error al ajustar la cantidad");
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .ajustar-cantidad-producto-final {
    background: #fff;
    padding: 25px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.05);
  }
  
  .alert-warning {
    background-color: #fff3cd;
    color: #856404;
    border-color: #ffeeba;
  }
  
  label {
    font-weight: 500;
  }
  
  input, textarea {
    font-size: 0.95rem;
  }
  
  .impacto {
    background-color: #f8f9fa;
    font-size: 0.9rem;
  }
  
  .text-success {
    color: #198754;
  }
  
  .text-danger {
    color: #dc3545;
  }
  </style>
  